<template>

  <div class="mit-apps-page mit-page">
      <MitEditApp :show="showOverlay" :editApp="editApp" v-on:save="saveApp" v-on:cancel="cancelDialog"/>
      <v-container>
        <v-row>
          <v-col cols="12" class="d-flex justify-left">
            <v-btn @click="showCreateAppDialog()">Add App</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="d-flex justify-left">
            <div class="pa-2">
              <h3 class="pb-2">TIG Apps</h3>
              <v-toolbar flat class="mb-2">
                <v-text-field class="mr-10" hide-details solo placeholder="Enter app name" v-model="searchOptions.appId"></v-text-field>
                <v-btn @click="getApps()">Refresh</v-btn>
              </v-toolbar>
              <v-data-table
                :headers="headers"
                :items="apps"
                :items-per-page="paging.pageSize"
                :server-items-length="paging.totalItems"
                :page="paging.page"
                class="elevation-1"
                @pagination="updatePagination"
              >
                <template v-slot:item.action="{ item }">
                  <v-btn @click="showEditAppDialog(item)">EDIT</v-btn>
                </template>
              </v-data-table>
            </div>
          </v-col>
        </v-row>
    </v-container>
  </div>
</template>

<script>
  import {MitEventBus} from '../../main.js';
  import BaseMitLoading from '../../base/components/BaseMitLoading.vue';
  import MitEditApp from '../components/MitEditApp.vue';
  import MitAppsService from '../services/MitAppsService.js';

  export default {
    name: 'MitAppPage',
    components: {
      BaseMitLoading,
      MitEditApp
    },
    data: function() {
      return {
        headers: [
                    {
                      text: 'App Id',
                      align: 'start',
                      sortable: true,
                      value: 'appId',
                    },
                    { text: 'Enabled', value: 'enabled' },
                    { text: 'User Access', value: 'accessUsers' },
                    { text: 'Group Access', value: 'accessGroups' },
                    { text: 'Feature Toggles', value: 'featureToggle' },
                    { text: 'Created', value: 'createDate' },
                    { text: 'Last Edited', value: 'lastEditedDate' },
                    { text: "", value: "action" }
                  ],
        apps: [],
        editApp: null,
        roleNames:null,
        paging:{
          page:1,
          pageSize:5,
          totalItems:0
        },
        searchOptions:{
          appId:null
        },
        showOverlay:false,
        test:{}
      }
    },
    props: {
      userModel: Object, //comes from route
      userRoles: Object //comes from route
    },
    created() {
      //set a default of new user for now. This will get updated if a user edits someone
      this.editUser = MitAppsService.getNewDefaultApp();

      this.getApps();
    },
    methods: {
      showCreateAppDialog(){
        this.editApp = MitAppsService.getNewDefaultApp();
        this.showOverlay = true;
      },
      showEditAppDialog (item){
        this.editApp = item;
        this.showOverlay = true;
      },
      updatePagination (pagination) {
        this.paging.page = pagination.page;
        this.paging.pageSize = pagination.itemsPerPage;

        this.getApps();
      },
      cancelDialog(){
        this.showOverlay = false;
      },
      saveApp(){

        for (let key in this.editApp.access) {
          if(typeof this.editApp.access[key] === 'string'){
            //convert to array, result of editing
            this.editApp.access[key] = this.editApp.access[key].replace(/\s/g, '');//remove all spaces
            this.editApp.access[key] = this.editApp.access[key].split(",");//split on , back to an array
          }
        }

        MitAppsService.saveApp(this.editApp)
          .then((user) => {
            this.getApps();
          })
          .catch((error) => {
            console.log('An error occurred saving user', error);

            MitEventBus.$emit('mit-alert--set-alert', {
              message:'An error occurred trying to create user.',
              timeoutMs:3000
            });

          });
          this.showOverlay = false;
      },
      getApps(){
        MitAppsService.getApps( this.paging.page, this.paging.pageSize, this.searchOptions)
          .then((apps) => {
            this.apps = apps.data;
            this.paging.totalItems = apps.total;
          })
          .catch((error) => {
            console.log('An error occurred trying to get user list', error);

            MitEventBus.$emit('mit-alert--set-alert', {
              message:'An error occurred trying get list of users.',
              timeoutMs:3000
            });
          });
      },
    }
  }
</script>

<style lang="scss" scoped>
  .mit-app-loading-center {
    display: flex;
    align-items: center;
    justify-content: center;
    height:100vh;
  }
</style>
